module.exports = __webpack_public_path__ + "img/explainC.0084cd2c.png";